import { getFileStorageUrl, getFileStorageUrlSync } from "@/utils/storage";
import * as React from "react";
interface PictureAvatarType {
  className: string;
  image: string;
  isLoading: boolean;
}
export default function PictureAvatar({
  className,
  image,
  isLoading,
}: PictureAvatarType) {
  const [imageUrl, setImageUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
     getFileStorageUrl(image).then((res) => {
        setImageUrl(res);
     })
  }, [image])

  return (
    <div className={`${className} relative aspect-square`}>
      <img src="/assets/mint-avatar-square-bg.png" />
      <div className="absolute w-[calc(100%-17px)] aspect-square z-[4] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
        <img src="/assets/avatar-bg.png" alt="avatar" />
      </div>
      {isLoading ? (
        <div className="absolute w-[calc(100%-18px)] aspect-square z-[3] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-[#525252] flex flex-col line-height-25 items-center justify-center text-[24px]">
          <span>LOADING</span>
          <span>MEDIA</span>
        </div>
      ) : (
        <div className="absolute w-[calc(100%-18px)] aspect-square z-[3] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
          <img src={imageUrl || getFileStorageUrlSync(image)} alt="avatar" />
        </div>
      )}
    </div>
  );
}
